import React, { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import { FallBackError } from 'components';
import { ErrorBoundary } from 'react-error-boundary';

const OnErrorHandler = context => (error, componentStack) => {
  const { logError, logInfo } = context;
  try {
    logError(
      context,
      'An Error Occured in Protocol Application',
      componentStack,
      {},
      {},
      error
    );
  } catch (err) {
    logInfo(err);
  }
};


const CTSUErrorBoundary = ({ children }) => {
  const context = useContext(AppContext);
  return (
    <ErrorBoundary
      FallbackComponent={FallBackError}
      onError={OnErrorHandler(context)}
    >
      {children}
    </ErrorBoundary>
  );
};

export default CTSUErrorBoundary;
